const QuickCart = {
  opened: false,
  loaded: false,

  /**
   * Loads required stuff
   */
  init: () => {
    QuickCart.events();
  },

  /**
   * Events
   */
  events: () => {
    // On toggles quick cart click
    $("body").on("click", ".toggle-quick-cart", () => {
      if (QuickCart.opened) {
        QuickCart.close();
      } else {
        QuickCart.open();
      }
    });

    // On quickart close.
    $("body").on("click", ".quick-cart__close", QuickCart.close);

    $(".quick-cart").on("click", (e) => {
      if (e.target == e.currentTarget) {
        QuickCart.close();
      }
    });

    // On remove click
    $("body").on("click", ".qc-product__remove", (e) => {
      QuickCart.removeProduct($(e.currentTarget)); //$(e.target)why this was working in production?
    });

    // Handle product change
    let quantityTimeout;
    $("#quick-cart").on("change", ".number-input input", function () {
      let input = $(this);

      $(this).attr('data-change-done', '1');

      if (quantityTimeout !== undefined) {
        clearTimeout(quantityTimeout);
      }

      quantityTimeout = setTimeout(function () {
        QuickCart.changeQuantity(input);
      }, 500);
    });

    // Coupon handling
    $("body").on("click", "#apply_coupon", function (e) {
      e.preventDefault();
      const buttonEl = $(this);

      const couponEl = $("#coupon_code");
      const couponCode = couponEl.val();

      if (!couponCode || couponCode.length < 1) {
        couponEl.addClass("error");
        $(".coupon-error").text(translations.coupon_empty);
        return;
      }

      buttonEl.attr("disabled", true);
      buttonEl.addClass("disabled");
      buttonEl.find(".btn-loader").removeClass("hidden");

      $.ajax({
        type: "POST",
        url: ajaxurl,
        data: {
          action: "handle_coupon",
          type: "add",
          code: couponCode,
        },
      }).done((resp) => {
        if (resp.content) {
          $("#quick-cart").html(resp.content);
        }
        if (resp.message) {
          $(".coupon-error").text(resp.message);
        }

        buttonEl.removeAttr("disabled");
        buttonEl.removeClass("disabled");
        buttonEl.find(".btn-loader").addClass("hidden");
      });
    });

    $("body").on("click", ".remove-coupon", function (e) {
      e.preventDefault();
      const buttonEl = $(this);

      const couponCode = $(this).data("coupon");

      buttonEl.attr("disabled", true);
      buttonEl.addClass("disabled");
      buttonEl.find(".btn-loader").removeClass("hidden");

      $.ajax({
        type: "POST",
        url: ajaxurl,
        data: {
          action: "handle_coupon",
          type: "remove",
          code: couponCode,
        },
      }).done((resp) => {
        // console.log(resp.content);
        if (resp.content) {
          $("#quick-cart").html(resp.content);
        }
        if (resp.message) {
          $(".coupon-error").text(resp.message);
        }

        buttonEl.removeAttr("disabled");
        buttonEl.removeClass("disabled");
        buttonEl.find(".btn-loader").addClass("hidden");
      });
    });
  },

  /**
   * Opens quick cart
   */
  open: () => {
    $(".quick-cart").addClass("quick-cart--open");
    $("html").addClass("no-scroll");

    QuickCart.opened = true;

    if (!QuickCart.loaded) {
      QuickCart.load();
    }
  },

  /**
   * Closes quick cart
   */
  close: () => {
    $(".quick-cart").removeClass("quick-cart--open");

    QuickCart.opened = false;

    $("html").removeClass("no-scroll");
  },

  /**
   * Loads quick cart data
   */
  load: () => {
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "render_quick_cart",
      },
    }).done((response) => {
      $(".quick-cart").find(".quick-cart__loader").remove();
      $("#quick-cart").html(response);
      $(".quick-cart").addClass("quick-cart--loaded");
    });
  },

  /**
   * Clears cart
   */
  clear: () => {
    QuickCart.loaded = false;
    $(".quick-cart").removeClass("quick-cart--loaded");
    // removes count
    $(".header-link--cart span").text(0);
    $(".header-link--cart").removeClass("tooltip--visible");
  },

  /**
   * Removes product from cart
   */
  removeProduct: (btn) => {
    let nonce = btn.data("nonce");
    let product_id = btn.data("id");

    // TODO Add loader

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "remove_from_cart",
        product_id: product_id,
        nonce: nonce,
      },
    })
      .done((response) => {
        if (response.empty) {
          // Displays empty cart
          $("#quick-cart").html(response.html);
          // removes count
          $(".header-link--cart span").text(0);
          $(".header-link--cart").removeClass("tooltip--visible");
        } else {
          // Reload cart to ensure offer products are updated correctly
          QuickCart.load();
          // Updates cart count.
          $(".header-link--cart span").text(response.count);
        }

        // TODO change product btn if id's match
        $(`.toggle-quick-cart[data-prod-id=${response.btn_id}]`).replaceWith(
          response.button
        );
      })
      .always(() => {});
  },

  changeQuantity: function (input) {
    let regex = /cart\[(.*?)\]\[qty\]/;
    let found = input.attr("name").match(regex);

    if (!found[1]) {
      return;
    }
    let item_key = found[1];
    let qty = input.val();

    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "update_cart_item_quantity",
        item_key: item_key,
        qty: qty,
      },
      beforeSend: () => {
        input.parent().addClass("number-input--disabled");
      },
      success: (response) => {
        input.parent().removeClass("number-input--disabled");
        QuickCart.reloadPrice(response);
      },
    });
  },

  /**
   * Regens cart prices
   */
  reloadPrice: (cartData) => {
    let cart = $(".quick-cart");

    // Track if cart structure changed (products added/removed by backend)
    let productsRemoved = false;
    let currentProductKeys = [];

    if (cartData.items) {
      cart.find(".qc-product").each(function () {
        let item = $(this);
        let item_key = item.data("key");
        currentProductKeys.push(item_key);
        if (cartData.items[item_key]) {
          let itemData = cartData.items[item_key];
          item.find(".qc-product__price").html(itemData.price);
        } else {
          // Item is no longer in cart (e.g., cart offer product removed)
          item.fadeOut(300, function() {
            $(this).remove();
          });
          productsRemoved = true;
        }
      });

      // Check if any new products were added by backend (e.g., tier product added)
      let responseProductKeys = Object.keys(cartData.items);
      let productsAdded = responseProductKeys.some(key => !currentProductKeys.includes(key));

      // If cart structure changed significantly, reload entire cart
      if (productsAdded) {
        QuickCart.load();
        return;
      }
    }
    if (cartData.total) {
      cart.find(".qc__total").html(cartData.total);
    }
    if (cartData.discount) {
      cart.find(".total-discount").removeClass("hidden");
      cart.find(".qc__discount").html(cartData.discount);
    } else {
      cart.find(".total-discount").addClass("hidden");
    }
    // Handle multiple fees
    if (cartData.fees && cartData.fees.length > 0) {
      // Remove existing fee boxes
      cart.find(".fee-box").remove();

      // Add each fee
      const feesContainer = cart.find(".qc-products__totals .total-discount").length
        ? cart.find(".qc-products__totals .total-discount")
        : cart.find(".qc-products__totals");

      cartData.fees.forEach((fee, index) => {
        if (fee.amount > 0.01) {
          const feeHtml = `
            <div class="flexbox-full h-sb fee-box">
              <div class="col-80 qc-product__text">${fee.name}</div>
              <div class="col qc-product__text qc__fee">${fee.formatted_amount}</div>
            </div>
          `;

          if (cart.find(".qc-products__totals .total-discount").length) {
            cart.find(".qc-products__totals .total-discount").after(feeHtml);
          } else {
            cart.find(".qc-products__totals").prepend(feeHtml);
          }
        }
      });
    } else {
      cart.find(".fee-box").remove();
    }
    if (cartData.count != "null") {
      QuickCart.displayCartCount(cartData.count);
    }

    if (cartData.empty) {
      $("#quick-cart").html(cartData.empty);
    }

    // When fee state changes: reload so correct bars are shown (fee bar vs free-shipping bar; tier-1 always)
    if (cartData.has_small_order_fee !== undefined) {
      const feeBar = cart.find(".cart-offer-bar--small-order-fee.cart-fee-bar");
      const freeShippingBar = cart.find(".free-shipping-bar");
      const shouldShowFeeBar = cartData.has_small_order_fee === true;
      if (shouldShowFeeBar && (freeShippingBar.length || (cart.find(".cart-offer-bar--tier-1").length && !feeBar.length))) {
        QuickCart.load();
        return;
      }
      if (!shouldShowFeeBar && feeBar.length) {
        QuickCart.load();
        return;
      }
    }

    // Update free shipping progress bar
    if (cartData.cart_total_raw !== undefined) {
      const freeShippingBar = cart.find(".free-shipping-bar");
      if (freeShippingBar.length) {
        const threshold = parseFloat(freeShippingBar.data("threshold"));
        const message = freeShippingBar.data("message");
        const successMessage = freeShippingBar.data("success-message");
        const cartTotal = parseFloat(cartData.cart_total_raw);

        const remainingAmount = threshold - cartTotal;
        const progressPercentage = Math.min(100, (cartTotal / threshold) * 100);

        if (remainingAmount > 0) {
          // Still below threshold - show progress bar
          // Format number with 2 decimals
          const remainingFormatted = remainingAmount.toFixed(2);

          const updatedMessage = message.replace("{amount}", ' <span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">\u20ac</span>' + remainingFormatted + '</bdi></span>');

          // Update message content only (preserve the SVG icon)
          freeShippingBar.find(".free-shipping-bar__content").html(updatedMessage);

          // Update or create progress bar
          if (freeShippingBar.find(".free-shipping-bar__progress").length === 0) {
            // Add progress bar if it doesn't exist (inside the free-shipping-bar, after the message)
            freeShippingBar.find(".free-shipping-bar__message").after(
              '<div class="free-shipping-bar__progress">' +
                '<div class="free-shipping-bar__progress-fill" style="width: ' + progressPercentage + '%;"></div>' +
              '</div>'
            );
          } else {
            // Update existing progress bar
            freeShippingBar.find(".free-shipping-bar__progress-fill").css("width", progressPercentage + "%");
          }
        } else {
          // Threshold reached - show success message in content div
          freeShippingBar.find(".free-shipping-bar__content").html(successMessage);
          // Remove progress bar
          freeShippingBar.find(".free-shipping-bar__progress").remove();
        }
      }

      // Update cart offer progress bars (handle both tier 1 and tier 2)
      const cartTotal = parseFloat(cartData.cart_total_raw);

      // Update small order fee bar (when fee is applied: "add X to remove fee") – message only, no progress bar
      const feeBar = cart.find(".cart-offer-bar--small-order-fee.cart-fee-bar");
      if (feeBar.length) {
        const feeThreshold = parseFloat(feeBar.data("threshold"));
        const feeRemaining = feeThreshold - cartTotal;
        if (feeRemaining > 0) {
          const feeRemainingFormatted = feeRemaining.toFixed(2);
          const feeAmountHtml = '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">€</span>' + feeRemainingFormatted + '</bdi></span>';
          const feeMessageTpl = feeBar.data("message") || (typeof translations !== "undefined" && translations.small_order_fee_message) || 'Lisa veel <strong>{amount}</strong> tooteid ostukorvi, et vabaneda väikese tellimuse töötlustasust.';
          feeBar.find(".cart-offer-bar__message").html(String(feeMessageTpl).replace("{amount}", feeAmountHtml));
        } else {
          // Crossed threshold; full reload will replace this bar with tier-1 or remove fee
          QuickCart.load();
          return;
        }
      }

      // Update Tier 1 progress bar
      const tier1Bar = cart.find(".cart-offer-bar--tier-1");
      if (tier1Bar.length) {
        const tier1Threshold = parseFloat(tier1Bar.data("threshold"));
        const tier1ProductName = tier1Bar.data("product-name");
        const tier1Price = parseFloat(tier1Bar.data("offer-price"));
        const tier1Info = tier1Bar.data("offer-info");
        const tier1SuccessMessage = tier1Bar.data("success-message");
        const wasAboveTier1 = tier1Bar.data("was-above-threshold") === true;

        const tier1Remaining = tier1Threshold - cartTotal;
        const tier1Progress = Math.min(100, (cartTotal / tier1Threshold) * 100);

        if (tier1Remaining > 0) {
          // Update tier 1 progress bar

          // Check if we just went back below threshold (was above, now below)
          if (wasAboveTier1) {
            // Crossed back down - reload cart to remove tier 1 offer product
            QuickCart.load();
            return;
          }

          const tier1RemainingFormatted = tier1Remaining.toFixed(2);
          const tier1PriceFormatted = tier1Price.toFixed(2);

          // Get the message template from data attribute
          let tier1MessageTemplate = tier1Bar.data("progress-message") || (typeof translations !== "undefined" && translations.cart_offer_progress_message) || 'Lisa veel <strong>{remaining_amount}</strong>, et saada <strong>{product_name}</strong> hinnaga <strong>{offer_price}</strong>';

          // Replace placeholders with formatted values
          const tier1Message = tier1MessageTemplate
            .replace('{remaining_amount}', '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">\u20ac</span>' + tier1RemainingFormatted + '</bdi></span>')
            .replace('{product_name}', tier1ProductName)
            .replace('{offer_price}', '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">\u20ac</span>' + tier1PriceFormatted + '</bdi></span>');

          tier1Bar.find(".cart-offer-bar__message").html(tier1Message);
          tier1Bar.find(".cart-offer-bar__progress-fill").css("width", tier1Progress + "%");
          tier1Bar.removeClass("cart-offer-bar--success");
          tier1Bar.data("was-above-threshold", false);
        } else {
          // Tier 1 threshold reached
          if (!wasAboveTier1) {
            // First time crossing - reload cart
            QuickCart.load();
            return;
          }
          // Update tier 1 to success state
          tier1Bar.addClass("cart-offer-bar--success");
          tier1Bar.find(".cart-offer-bar__message")
            .addClass("cart-offer-bar__message--success")
            .html(tier1SuccessMessage);
          tier1Bar.find(".cart-offer-bar__progress").remove();
          tier1Bar.find(".cart-offer-bar__info").remove();
          tier1Bar.data("was-above-threshold", true);
        }
      }

      // Update Tier 2 progress bar
      const tier2Bar = cart.find(".cart-offer-bar--tier-2");
      if (tier2Bar.length) {
        const tier2Threshold = parseFloat(tier2Bar.data("threshold"));
        const tier2ProductName = tier2Bar.data("product-name");
        const tier2Price = parseFloat(tier2Bar.data("offer-price"));
        const tier2Info = tier2Bar.data("offer-info");
        const tier2SuccessMessage = tier2Bar.data("success-message");
        const wasAboveTier2 = tier2Bar.data("was-above-threshold") === true;

        const tier2Remaining = tier2Threshold - cartTotal;
        const tier2Progress = Math.min(100, (cartTotal / tier2Threshold) * 100);

        if (tier2Remaining > 0) {
          // Update tier 2 progress bar

          // Check if we just went back below threshold (was above, now below)
          if (wasAboveTier2) {
            // Crossed back down - reload cart to remove tier 2 offer product
            QuickCart.load();
            return;
          }

          const tier2RemainingFormatted = tier2Remaining.toFixed(2);
          const tier2PriceFormatted = tier2Price.toFixed(2);

          // Get the message template from data attribute
          let tier2MessageTemplate = tier2Bar.data("progress-message") || (typeof translations !== "undefined" && translations.cart_offer_progress_message) || 'Lisa veel <strong>{remaining_amount}</strong>, et saada <strong>{product_name}</strong> hinnaga <strong>{offer_price}</strong>';

          // Replace placeholders with formatted values
          const tier2Message = tier2MessageTemplate
            .replace('{remaining_amount}', '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">\u20ac</span>' + tier2RemainingFormatted + '</bdi></span>')
            .replace('{product_name}', tier2ProductName)
            .replace('{offer_price}', '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">\u20ac</span>' + tier2PriceFormatted + '</bdi></span>');

          tier2Bar.find(".cart-offer-bar__message").html(tier2Message);
          tier2Bar.find(".cart-offer-bar__progress-fill").css("width", tier2Progress + "%");
          tier2Bar.removeClass("cart-offer-bar--success");
          tier2Bar.data("was-above-threshold", false);
        } else {
          // Tier 2 threshold reached
          if (!wasAboveTier2) {
            // First time crossing - reload cart
            QuickCart.load();
            return;
          }
          // Update tier 2 to success state
          tier2Bar.addClass("cart-offer-bar--success");
          tier2Bar.find(".cart-offer-bar__message")
            .addClass("cart-offer-bar__message--success")
            .html(tier2SuccessMessage);
          tier2Bar.find(".cart-offer-bar__progress").remove();
          tier2Bar.find(".cart-offer-bar__info").remove();
          tier2Bar.data("was-above-threshold", true);
        }
      }
    }
  },

  displayCartCount: (count) => {
    var btn = $(".cart-btn");
    count = parseInt(count);

    switch (true) {
      case count > 0 && btn.find(".tooltip").length > 0:
        btn.find(".tooltip").html(count);
        btn.find(".tooltip").addClass("tooltip--visible");
        break;

      case count > 0:
        btn.append('<span class="tooltip">' + count + "</span>");
        btn.find(".tooltip").addClass("tooltip--visible");
        break;

      case btn.find(".tooltip").length > 0:
        btn.find(".tooltip").html("");
        btn.find(".tooltip").removeClass("tooltip--visible");
        break;
    }
  },
};

export default QuickCart;
